import { render } from "./Certify.vue?vue&type=template&id=6a9fc28a"
import script from "./Certify.vue?vue&type=script&lang=js"
export * from "./Certify.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__